import { PLink, PLinkPure } from '@porsche-design-system/components-react';
import { type AnchorProps } from '../context';

const getPorscheLinkVariant = (colorSet: AnchorProps['colorSet']) => {
    switch (colorSet) {
        case 'primary':
            return 'primary';

        default:
            return 'secondary';
    }
};

const Anchor = ({
    children,
    variant = 'ghost',
    colorSet = 'primary',
    icon,
    porscheFallbackIcon = 'none',
    porscheFallbackIconSource,
    ...props
}: AnchorProps) => {
    if (variant === 'ghost') {
        return (
            <PLinkPure {...props} icon={porscheFallbackIcon} iconSource={porscheFallbackIconSource}>
                {children}
            </PLinkPure>
        );
    }

    return (
        <PLink
            {...props}
            icon={porscheFallbackIcon}
            iconSource={porscheFallbackIconSource}
            variant={getPorscheLinkVariant(colorSet)}
        >
            {children}
        </PLink>
    );
};

export default Anchor;
